/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { JsonFormSerializationBuilder } from "../../FormLoader/src/JsonFormSerializationBuilder";
import { FormFieldMappingStatus } from "./IFormSerializationResult";
import { FormSerializer } from "../../FormLoader/src/FormSerializer";
import { findCheckboxes, getParentElement } from "../../FormLoader/src/Utils/HtmlUtils";
import { createFormSubmissionCookie } from "../../FormLoader/src/Utils/FormSubmissionCookieUtils";
var FormCapture = /** @class */ (function () {
    function FormCapture(logger, formServiceClient) {
        this.logger = logger;
        this.formServiceClient = formServiceClient;
    }
    FormCapture.prototype.serializeForm = function (form, mappings, location) {
        var _this = this;
        var builder = new JsonFormSerializationBuilder(location, "FormCapture");
        var result = {
            FormFieldMappingResults: [],
            SerializedForm: builder
        };
        var elements = form.elements;
        mappings.forEach(function (m) {
            var _a, _b;
            var mappingResult = { Mapping: m, Message: "", FormFieldMappingStatus: FormFieldMappingStatus.NotFound };
            try {
                if (m.FormFieldName) {
                    // field mapped to form
                    var item = elements.namedItem(m.FormFieldName);
                    var itemRadioList = item;
                    var itemElement = item;
                    if (((_a = itemRadioList === null || itemRadioList === void 0 ? void 0 : itemRadioList.constructor) === null || _a === void 0 ? void 0 : _a.name) == "RadioNodeList" ||
                        (((_b = itemRadioList === null || itemRadioList === void 0 ? void 0 : itemRadioList.constructor) === null || _b === void 0 ? void 0 : _b.name) == null && (itemRadioList === null || itemRadioList === void 0 ? void 0 : itemRadioList.forEach))) {
                        itemRadioList.forEach(function (node) {
                            _this.serializeElement(node, m, builder);
                        });
                        mappingResult.FormFieldMappingStatus = FormFieldMappingStatus.Success;
                    }
                    else if (itemElement) {
                        _this.serializeElement(itemElement, m, builder);
                        mappingResult.FormFieldMappingStatus = FormFieldMappingStatus.Success;
                    }
                    else {
                        _this.logger.warn("Could not find element with name ".concat(m.FormFieldName, " mapped to ").concat(m.DataverseFieldName));
                        mappingResult.FormFieldMappingStatus = FormFieldMappingStatus.NotFound;
                    }
                }
                else if (m.DataverseFieldValue && typeof m.DataverseFieldValue === "string") {
                    // static value
                    builder.add(m.DataverseFieldName, m.DataverseFieldValue);
                    mappingResult.FormFieldMappingStatus = FormFieldMappingStatus.Success;
                }
            }
            catch (e) {
                _this.logger.error(e);
                mappingResult.Message = "Failed to map field ".concat(m.FormFieldName, ": ").concat(e);
                mappingResult.FormFieldMappingStatus = FormFieldMappingStatus.Error;
            }
            finally {
                result.FormFieldMappingResults.push(mappingResult);
            }
        });
        return result;
    };
    FormCapture.prototype.submitForm = function (captureConfig, serializedForm) {
        return __awaiter(this, void 0, void 0, function () {
            var formId, submitFormUrl, payload, response, error, e_1, error, error;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        formId = captureConfig === null || captureConfig === void 0 ? void 0 : captureConfig.FormId;
                        if (!(formId && captureConfig.FormApiUrl)) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        submitFormUrl = "".concat(captureConfig.FormApiUrl, "/forms/").concat(formId);
                        payload = serializedForm.data;
                        return [4 /*yield*/, this.formServiceClient.submitForm(submitFormUrl, payload)];
                    case 2:
                        response = _a.sent();
                        if (response.submissionStatus != "OK" && response.submissionStatus != 0) {
                            error = "Submission of form with id ".concat(formId, " was rejected with submission status ").concat(response.submissionStatus, " and message ").concat(response.errorMessage);
                            this.logger.error(error);
                            return [2 /*return*/, Promise.reject(error)];
                        }
                        createFormSubmissionCookie(response.formSubmissionId, this.logger);
                        return [2 /*return*/, Promise.resolve(response)];
                    case 3:
                        e_1 = _a.sent();
                        error = "Failed to submit form with id ".concat(formId, " with error ").concat(e_1);
                        this.logger.error(error);
                        return [2 /*return*/, Promise.reject(error)];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        error = "Capture configuration for form not defined or invalid";
                        this.logger.error(error);
                        return [2 /*return*/, Promise.reject(error)];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    FormCapture.prototype.serializeElement = function (element, m, builder) {
        if (element.nodeName == "INPUT") {
            var input = element;
            if (input.type === "checkbox") {
                var parent = getParentElement(input, function (element) { return element.nodeName === "FIELDSET"; });
                if (parent && parent["name"] === input["name"]) {
                    // multi-select checkbox scenario
                    return;
                }
            }
        }
        if (element && m.DataverseFieldValue) {
            if (typeof m.DataverseFieldValue === "string") {
                element = this.setElementValue(element, m.DataverseFieldValue);
            }
            else {
                element = this.mapElementValues(element, m.DataverseFieldValue);
            }
        }
        FormSerializer.serializeElement(element, m.DataverseFieldName, builder);
    };
    FormCapture.prototype.setElementValue = function (original, value) {
        var element = original.cloneNode(true);
        switch (element.nodeName) {
            case "INPUT":
            case "TEXTAREA":
            case "BUTTON":
                var inputElement = element;
                inputElement.value = value;
                return inputElement;
            default:
                this.logger.log("ignored element with unknown type: ".concat(typeof element));
                break;
        }
        return original;
    };
    FormCapture.prototype.mapElementValues = function (original, value) {
        var element = original.cloneNode(true);
        switch (element.nodeName) {
            case "INPUT":
            case "TEXTAREA":
            case "BUTTON":
                var inputElement_1 = element;
                var dvValue = value.find(function (m) { return m.FormValue == inputElement_1.value; });
                if (dvValue) {
                    inputElement_1.value = dvValue.DataverseValue;
                }
                return inputElement_1;
            case "SELECT":
                var selectElement = element;
                var selectedValue = original.value;
                var _loop_1 = function () {
                    var option = selectElement.options[i];
                    if (option.value == selectedValue) {
                        var mappingValue = value;
                        var dvValue_1 = mappingValue.find(function (m) { return m.FormValue == option.value; });
                        if (dvValue_1) {
                            option.value = dvValue_1.DataverseValue;
                            selectedValue = option.value;
                            return "break";
                        }
                    }
                };
                for (var i = 0; i < selectElement.options.length; i++) {
                    var state_1 = _loop_1();
                    if (state_1 === "break")
                        break;
                }
                selectElement.value = selectedValue;
                return selectElement;
            case "FIELDSET":
                var fsElement = element;
                var checkboxes = findCheckboxes(fsElement);
                if (checkboxes === null || checkboxes === void 0 ? void 0 : checkboxes.length) {
                    checkboxes.forEach(function (checkbox) {
                        var mappingValue = value;
                        var dvValue = mappingValue.find(function (m) { return m.FormValue == checkbox.value; });
                        if (dvValue) {
                            checkbox.value = dvValue.DataverseValue;
                        }
                    });
                }
                return fsElement;
            default:
                this.logger.log("ignored element with unknown type: ".concat(typeof element));
                break;
        }
        return original;
    };
    return FormCapture;
}());
export { FormCapture };
